import { DESCRIPTION_COPY_LIMITS, TITLE_COPY_LIMITS } from "../copy-policy";
/** Resource cards with authored section labels and a section dropdown. */
import { RESOURCE_CARD_LOGO_SLOT } from "../resource-cards";
/** The parts of one resource an Editor fills in. Only the name is required. */
const RESOURCE_SCALAR_SLOTS = [
    { key: "name", label: "Name", type: "text" },
    {
        key: "description",
        ...DESCRIPTION_COPY_LIMITS,
        label: "Description",
        type: "textarea",
    },
    { key: "linkText", label: "Link text", type: "text" },
    { key: "url", label: "Link URL", type: "url" },
];
export const resourceCardsSchema = {
    componentId: "ResourceCards",
    scalarSlots: [
        { key: "heading", ...TITLE_COPY_LIMITS, label: "Title", type: "text" },
        {
            key: "subheading",
            ...DESCRIPTION_COPY_LIMITS,
            label: "Description",
            type: "textarea",
        },
        { key: "sectionOneLabel", label: "Section 1 label", type: "text" },
        { key: "sectionTwoLabel", label: "Section 2 label", type: "text" },
    ],
    mediaSlots: [],
    repeatSlots: [
        {
            key: "sections",
            label: "Additional sections",
            itemLabel: "Section",
            scalarSlots: [{ key: "label", label: "Section label", type: "text" }],
            mediaSlots: [],
        },
        {
            key: "resources",
            label: "Additional section resources",
            itemLabel: "Resource",
            scalarSlots: [
                {
                    key: "sectionId",
                    label: "Section",
                    type: "select",
                    optionsRepeat: "sections",
                },
                ...RESOURCE_SCALAR_SLOTS,
            ],
            mediaSlots: [RESOURCE_CARD_LOGO_SLOT],
        },
        {
            key: "sectionOneResources",
            label: "Section 1 resources",
            itemLabel: "Resource",
            scalarSlots: RESOURCE_SCALAR_SLOTS,
            // Built from the one declaration in `../resource-cards`, so the size the
            // picker enforces and the size a stored reference is named by cannot drift.
            mediaSlots: [RESOURCE_CARD_LOGO_SLOT],
        },
        {
            key: "sectionTwoResources",
            label: "Section 2 resources",
            itemLabel: "Resource",
            scalarSlots: RESOURCE_SCALAR_SLOTS,
            mediaSlots: [RESOURCE_CARD_LOGO_SLOT],
        },
    ],
};
//# sourceMappingURL=resource-cards.js.map